import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ObjectBrowserModule } from '../object-browser';
import { SelectExistingLayerComponent } from './select-existing-layer.component';

@NgModule({
    declarations: [SelectExistingLayerComponent],
    imports: [CommonModule, TwcModule, TranslateModule, FormsModule, ReactiveFormsModule, ObjectBrowserModule],
    exports: [SelectExistingLayerComponent],
})
export class SelectExistingLayerModule {}
